import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IExchangeConfig } from '.';
import { BidClient } from '../core/clients';
import { axiosToObservable } from '../core/clients/axiosToObservable';

export class ExchangeConfigService {
    getAllExchangeConfig = (): Observable<IExchangeConfig[]> => {
        return axiosToObservable(BidClient.get<IExchangeConfig[]>('ExchangeConfig/GetAllExchangeConfig/')).pipe(
            map((exchanges: IExchangeConfig[]) => {
                return exchanges;
            })
        );
  };

  postExchangeConfigUpdate = (exchangeConfig: IExchangeConfig): Observable<any> => {
    return axiosToObservable(BidClient.post('ExchangeConfig/Update/', exchangeConfig)).pipe(
      map((response: any) => {
        return response;
      })
    );
  };
}

export class ExchangeConfigServiceByExchange {
    getAllExchangeConfig = (): Observable<IExchangeConfig[]> => {
        return axiosToObservable(BidClient.get<IExchangeConfig[]>('ExchangeConfig/GetAllExchangeConfigByExchange/?exchangeId=1')).pipe(
            map((exchanges: IExchangeConfig[]) => {
                return exchanges;
            })
        );
    };
}
